export const BACKEND_URL: string='https://api.air-austral.smart-evaluator.com'
